"use strict";
// AUTO-GENERATED - DO NOT EDIT
// Generated from: src/schemas/public/merchant.schemas.ts
// Convention: See SCHEMA_NAMING_CONVENTION.md
Object.defineProperty(exports, "__esModule", { value: true });
